import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47f85ef4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { class: "merchantname-title ion-text-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "title-text" }
const _hoisted_6 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_7 = {
  key: 2,
  class: "delivery-info ion-text-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "ion-text-center ion-padding-bottom subtitle" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-underline" }, null, -1))
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "ion-text-center" }
const _hoisted_16 = { class: "ion-padding-bottom subtitle" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-underline" }, null, -1))
const _hoisted_18 = { class: "pickup-text" }
const _hoisted_19 = { class: "ion-text-center ion-padding-bottom subtitle" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-underline" }, null, -1))
const _hoisted_21 = { class: "ion-text-center ion-padding-bottom subtitle" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-underline" }, null, -1))
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "ion-text-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjYzVkYmZmIiBkPSJNMCAwaDUxMnY1MTJIMHoiLz48cGF0aCBkPSJNMjU2IDMwNGM2MS42IDAgMTEyLTUwLjQgMTEyLTExMlMzMTcuNiA4MCAyNTYgODBzLTExMiA1MC40LTExMiAxMTIgNTAuNCAxMTIgMTEyIDExMnptMCA0MGMtNzQuMiAwLTIyNCAzNy44LTIyNCAxMTJ2NTZoNDQ4di01NmMwLTc0LjItMTQ5LjgtMTEyLTIyNC0xMTJ6IiBmaWxsPSIjODJhZWZmIi8+PC9zdmc+" }, null, -1))
const _hoisted_28 = { style: {"white-space":"pre-line"} }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider" }, null, -1))
const _hoisted_30 = {
  key: 1,
  class: "ion-text-center ion-margin-top"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_image_slides = _resolveComponent("image-slides")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_section_header = _resolveComponent("section-header")!
  const _component_swiper_category_data = _resolveComponent("swiper-category-data")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, {
    key: $setup.route.fullPath
  }, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        parentPath: $setup.parentPath ? $setup.parentPath : '/products'
      }, null, 8, ["parentPath"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              (!$setup.loading && $setup.product)
                ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_2, [
                                _createTextVNode(_toDisplayString($setup.product.merchantName) + " ", 1),
                                _createVNode(_component_ion_button, {
                                  class: "merchantname-button",
                                  fill: "clear",
                                  "router-link": `/merchants/${$setup.product.merchantId}`
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "end",
                                      icon: $setup.enterOutline
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 8, ["router-link"])
                              ])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("img", {
                            src: $setup.product.imageLink
                          }, null, 8, _hoisted_3),
                          ($setup.product.photoLinks && $setup.product.photoLinks.length >= 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_image_slides, {
                                  imageLinks: $setup.product.photoLinks,
                                  minSlidesPerView: 4,
                                  size: "small",
                                  hideEyeIcon: true,
                                  defaultCaption: $setup.getLocalizedStr($setup.product, 'title', 'titleEn')
                                }, null, 8, ["imageLinks", "defaultCaption"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, { size: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, {
                            class: "product-card ion-text-center ion-margin-bottom",
                            color: "medium"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("h5", _hoisted_5, _toDisplayString($setup.getLocalizedStr($setup.product, 'title', 'titleEn')), 1)
                                ]),
                                _: 1
                              }),
                              ($setup.product.sellingPrice != $setup.product.price)
                                ? (_openBlock(), _createBlock(_component_ion_card_title, {
                                    key: 0,
                                    class: "ion-text-center",
                                    color: "primary"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("s", null, "HK$" + _toDisplayString(Number($setup.product.price).toLocaleString()), 1),
                                      _createTextVNode(" HK$" + _toDisplayString(Number($setup.product.sellingPrice).toLocaleString()), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_ion_card_title, {
                                    key: 1,
                                    class: "product-price-card",
                                    color: "primary"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" HK$" + _toDisplayString(Number($setup.product.sellingPrice).toLocaleString()), 1)
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          }),
                          ($setup.product.inStock)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                _createVNode(_component_ion_button, {
                                  class: "action-btn buy-button",
                                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.openCartItemModal()), ["stop"]))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "start",
                                      icon: $setup.cartOutline
                                    }, null, 8, ["icon"]),
                                    _createTextVNode(" " + _toDisplayString($setup.t('addToCart')), 1)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : (_openBlock(), _createBlock(_component_ion_button, {
                                key: 1,
                                class: "ion-margin-bottom action-btn",
                                expand: "block",
                                color: "medium",
                                disabled: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.t('soldOut')), 1)
                                ]),
                                _: 1
                              })),
                          ($setup.product.earliestDeliveryDate)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createVNode(_component_ion_icon, {
                                  class: "icon",
                                  slot: "start",
                                  icon: $setup.timerOutline
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString($setup.t('earliestDeliveryDate')) + ": " + _toDisplayString($setup.product.earliestDeliveryDate), 1)
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.userLoggedIn && $setup.product.likedByUser)
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 3,
                                class: "ion-margin-bottom action-btn",
                                expand: "block",
                                fill: "outline",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateUserLikedItem($setup.product, 'remove')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.heart,
                                    color: "danger"
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString($setup.t('removeFromLikedItems')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          ($setup.userLoggedIn && !$setup.product.likedByUser)
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 4,
                                class: "ion-margin-bottom action-btn",
                                expand: "block",
                                fill: "outline",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateUserLikedItem($setup.product, 'add')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.heartOutline
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString($setup.t('addToLikedItems')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ion_button, {
                            class: "ion-margin-bottom action-btn",
                            expand: "block",
                            fill: "outline",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.shareProduct($setup.product)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                icon: $setup.shareSocialOutline
                              }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString($setup.t('shareProduct')), 1)
                            ]),
                            _: 1
                          }),
                          ($setup.userLoggedIn)
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 5,
                                class: "ion-margin-bottom action-btn",
                                expand: "block",
                                fill: "outline",
                                "router-link": {
              name: 'FeedbackPage',
              params: { passedProduct: JSON.stringify($setup.product) }
            }
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.chatbubbleEllipsesOutline
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString($setup.t('enquiry')), 1)
                                ]),
                                _: 1
                              }, 8, ["router-link"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, { size: "12" }, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _createVNode(_component_ion_grid, { fixed: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_toolbar, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_segment, {
                                    modelValue: $setup.pageTab,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.pageTab) = $event)),
                                    scrollable: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_segment_button, { value: "產品介紹" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString($setup.t('productIntro')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_segment_button, { value: "自取點" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString($setup.t('pickupPoints')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_segment_button, { value: "可送貨地區" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString($setup.t('deliveryDistricts')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_segment_button, { value: "預訂須知" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString($setup.t('orderNotice')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _hoisted_9,
                          _withDirectives(_createElementVNode("div", null, [
                            _createElementVNode("h2", _hoisted_10, _toDisplayString($setup.t('productIntro')), 1),
                            _hoisted_11,
                            _withDirectives(_createElementVNode("div", null, [
                              _createElementVNode("div", {
                                class: "content",
                                innerHTML: $setup.clipHtmlText( $setup.getLocalizedStr($setup.product, 'descriptionHtml', 'descriptionHtmlEn') )
                              }, null, 8, _hoisted_12),
                              ($setup.isHtmlOverTextLenLimit( $setup.getLocalizedStr($setup.product, 'descriptionHtml', 'descriptionHtmlEn') ))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode(_component_ion_button, {
                                      fill: "clear",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.showClippedText.productIntro = false))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.t('readMore')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ], 512), [
                              [_vShow, $setup.showClippedText.productIntro]
                            ]),
                            _withDirectives(_createElementVNode("div", null, [
                              _createElementVNode("div", {
                                class: "content",
                                innerHTML: $setup.getLocalizedStr($setup.product, 'descriptionHtml', 'descriptionHtmlEn')
                              }, null, 8, _hoisted_14)
                            ], 512), [
                              [_vShow, !$setup.showClippedText.productIntro]
                            ])
                          ], 512), [
                            [_vShow, $setup.pageTab == '產品介紹' && $setup.product.descriptionHtml]
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_15, [
                            _createElementVNode("h2", _hoisted_16, _toDisplayString($setup.t('pickupPoints')), 1),
                            _hoisted_17,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pickupPoints, (pickupPoint) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: pickupPoint.id
                              }, [
                                _createElementVNode("p", _hoisted_18, [
                                  _createVNode(_component_ion_icon, {
                                    class: "icon",
                                    icon: $setup.location
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString(pickupPoint.address), 1)
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getOpeningHoursText(pickupPoint), (text) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    class: "content",
                                    key: text
                                  }, _toDisplayString(text), 1))
                                }), 128))
                              ]))
                            }), 128))
                          ], 512), [
                            [_vShow, $setup.pageTab == '自取點']
                          ]),
                          _withDirectives(_createElementVNode("div", null, [
                            _createElementVNode("h2", _hoisted_19, _toDisplayString($setup.t('deliveryDistricts')), 1),
                            _hoisted_20,
                            _createVNode(_component_ion_toolbar, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_segment, {
                                  modelValue: $setup.deliveryDistrictFilter,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.deliveryDistrictFilter) = $event)),
                                  scrollable: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($setup.groupedDeliveryOptions), (region) => {
                                      return (_openBlock(), _createBlock(_component_ion_segment_button, {
                                        key: region,
                                        value: region
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString($setup.t(region)), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupedDeliveryOptions, (obj, region) => {
                              return _withDirectives((_openBlock(), _createElementBlock("div", { key: region }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(obj, (obj2, group) => {
                                  return (_openBlock(), _createBlock(_component_ion_list, { key: group }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(obj2, (districts, price) => {
                                        return (_openBlock(), _createBlock(_component_ion_item, { key: price }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(group) + "：" + _toDisplayString(districts.map(d => d.nameChi).join(" , ")), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_ion_note, {
                                              slot: "end",
                                              color: "primary"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("HK$" + _toDisplayString(price), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ])), [
                                [_vShow, $setup.deliveryDistrictFilter == region]
                              ])
                            }), 128))
                          ], 512), [
                            [_vShow, $setup.pageTab =='可送貨地區']
                          ]),
                          _withDirectives(_createElementVNode("div", null, [
                            _createElementVNode("h2", _hoisted_21, _toDisplayString($setup.t('orderNotice')), 1),
                            _hoisted_22,
                            _withDirectives(_createElementVNode("div", null, [
                              _createElementVNode("p", {
                                class: "content",
                                innerHTML: $setup.clipHtmlText($setup.product.orderNoticeHtml)
                              }, null, 8, _hoisted_23),
                              ($setup.isHtmlOverTextLenLimit($setup.product.orderNoticeHtml))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _createVNode(_component_ion_button, {
                                      fill: "clear",
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.showClippedText.orderNotice = false))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.t('readMore')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ], 512), [
                              [_vShow, $setup.showClippedText.orderNotice]
                            ]),
                            _withDirectives(_createElementVNode("div", null, [
                              _createElementVNode("p", {
                                class: "content",
                                innerHTML: $setup.product.orderNoticeHtml
                              }, null, 8, _hoisted_25)
                            ], 512), [
                              [_vShow, !$setup.showClippedText.orderNotice]
                            ])
                          ], 512), [
                            [_vShow, $setup.pageTab == '預訂須知' && $setup.product.orderNoticeHtml]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, { size: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_header, null, {
                                default: _withCtx(() => [
                                  ($setup.productReviews.length > 0)
                                    ? (_openBlock(), _createBlock(_component_ion_card_title, {
                                        key: 0,
                                        class: "subtitle"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString($setup.productReviews.length) + " " + _toDisplayString($setup.t('ProductPage.numOfCustomerReviews')), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_ion_card_title, {
                                        key: 1,
                                        class: "subtitle"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString($setup.t('ProductPage.noCustomerReviews')), 1)
                                        ]),
                                        _: 1
                                      })),
                                  ($setup.productReviews.length > 0)
                                    ? (_openBlock(), _createBlock(_component_ion_card_title, {
                                        key: 2,
                                        color: "warning"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.floor($setup.productOverallRating), (i) => {
                                            return (_openBlock(), _createBlock(_component_ion_icon, {
                                              key: i,
                                              icon: $setup.star
                                            }, null, 8, ["icon"]))
                                          }), 128)),
                                          ($setup.productOverallRating - Math.floor($setup.productOverallRating) > 0)
                                            ? (_openBlock(), _createBlock(_component_ion_icon, {
                                                key: 0,
                                                icon: $setup.starHalfOutline
                                              }, null, 8, ["icon"]))
                                            : _createCommentVNode("", true),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5-Math.ceil($setup.productOverallRating), (i) => {
                                            return (_openBlock(), _createBlock(_component_ion_icon, {
                                              key: i,
                                              icon: $setup.starOutline
                                            }, null, 8, ["icon"]))
                                          }), 128)),
                                          _createTextVNode(" " + _toDisplayString($setup.productOverallRating) + " / 5 ", 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              ($setup.product.purchasedByUser)
                                ? (_openBlock(), _createBlock(_component_ion_item, {
                                    key: 0,
                                    lines: "none"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_button, {
                                            fill: "outline",
                                            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.openNewReviewModal($setup.product)))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                slot: "start",
                                                icon: $setup.pencil
                                              }, null, 8, ["icon"]),
                                              _createTextVNode(" " + _toDisplayString($setup.t('ProductPage.newReview')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_row, null, {
                                default: _withCtx(() => [
                                  ($setup.loadingProductReviews)
                                    ? (_openBlock(), _createBlock(_component_ion_col, {
                                        key: 0,
                                        size: "12"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_26, [
                                            _createVNode(_component_ion_spinner)
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.productReviews, (review, index) => {
                                        return (_openBlock(), _createBlock(_component_ion_col, {
                                          size: "12",
                                          class: "ion-no-padding",
                                          key: review.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_card, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_card_header, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_card_subtitle, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" #" + _toDisplayString(index+1) + " ", 1),
                                                        _createVNode(_component_ion_chip, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_ion_avatar, null, {
                                                              default: _withCtx(() => [
                                                                _hoisted_27
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_ion_label, null, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(review.username), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_ion_card_content, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("p", _hoisted_28, _toDisplayString(review.content), 1),
                                                    _createVNode(_component_ion_item, {
                                                      class: "ion-no-padding",
                                                      lines: "none"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Number(review.rating), (i) => {
                                                          return (_openBlock(), _createBlock(_component_ion_icon, {
                                                            key: i,
                                                            color: "warning",
                                                            icon: $setup.star
                                                          }, null, 8, ["icon"]))
                                                        }), 128)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5-review.rating, (i) => {
                                                          return (_openBlock(), _createBlock(_component_ion_icon, {
                                                            key: i,
                                                            color: "warning",
                                                            icon: $setup.starOutline
                                                          }, null, 8, ["icon"]))
                                                        }), 128)),
                                                        _createVNode(_component_ion_note, { slot: "end" }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString($setup.formatDate(review.createdAt)), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", null, [
                _hoisted_29,
                _createVNode(_component_section_header, {
                  icon: $setup.star,
                  title: $setup.t('ProductPage.relatedProducts')
                }, null, 8, ["icon", "title"]),
                ($setup.showSlides)
                  ? (_openBlock(), _createBlock(_component_swiper_category_data, {
                      key: 0,
                      allCategories: $setup.relatedProducts.categories,
                      allProducts: $setup.relatedProducts.products,
                      hideMerchantName: true,
                      showActionButtons: true,
                      userLoggedIn: $setup.userLoggedIn
                    }, null, 8, ["allCategories", "allProducts", "userLoggedIn"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createVNode(_component_ion_spinner)
                    ]))
              ], 512), [
                [_vShow, !$setup.loading]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}